import {chartAreaRound, R, getPointRadius, getPointBorderWidth} from "./tools/tools";
import Chart from 'chart.js/auto';
import {initialChartLabels, initialChartData} from "./state-variables";

export const chartJsConfig = {
    type: "line",
    data: {
        labels: initialChartLabels.val,
        datasets: [{
            data: initialChartData.val,
            borderColor: "#28BF4E",
            borderWidth: R(0, 16, 32),
            fill: true,

            pointRadius: ctx => getPointRadius(ctx),
            pointHoverRadius: ctx => getPointRadius(ctx),
            pointBorderWidth: ctx => getPointBorderWidth(ctx),
            pointHoverBorderWidth: ctx => getPointBorderWidth(ctx),
            pointHitRadius: 0,
        }],
    },
    options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {display: false},
            tooltip: {enabled: false},
            chartAreaRound: {
                backgroundColor: "#FFF",
                radius: { bl: document.getElementById("root").offsetWidth < 992 ? 15 : 60 }
            }
        },
        scales: {
            x: {
                border: { display: false },
                afterBuildTicks(scale) {
                    if (scale.ticks.length > 2) scale.ticks = scale.ticks.slice(1, -1)
                },
                grid: {
                    color: "#45C0EA",
                    drawTicks: false,
                    drawBorder: false,
                },
                ticks: {
                    autoSkip: false,
                    color: "#00386F",
                    font: { size: document.getElementById("root").offsetWidth < 992 ? R(6, 40, 40) : R(0, 25, 45), weight: "600", family: "NeoSans, Roboto" },
                    padding: R(0, 25, 45),
                },
            },
            y: {
                border: { display: false },
                afterBuildTicks(scale) {
                    if (scale.ticks.length > 2) scale.ticks = scale.ticks.slice(1, -1)
                },
                grid: {
                    color: "#45C0EA",
                    drawTicks: false,
                    drawBorder: false,
                },
                ticks: {
                    autoSkip: false,
                    color: "#00386F",
                    font: { size: document.getElementById("root").offsetWidth < 992 ? R(6, 40, 40) : R(0, 25, 45), weight: "600", family: "NeoSans, Roboto" },
                    padding: R(0, 25, 45),
                    callback: (val) => val + " kWh"
                },
                min: 0,
            }
        }
    },
    plugins: [chartAreaRound]
}

export const drawChart = (context, canvas) => {
    const gradient = context.createLinearGradient(0, 0, 0, canvas.scrollHeight);
    gradient.addColorStop(0, "rgba(40, 191, 78, 1)");
    gradient.addColorStop(1, "rgba(40, 191, 78, 0.05)");
    chartJsConfig.data.datasets[0]['backgroundColor'] = gradient;
    return new Chart(context, chartJsConfig);
}